/*
  Kiwi Shop, 2026-10-22 (Gaurav). Loaded on every page from snippets/kiwi-forms-css.liquid, after
  assets/kiwi-ux.js. Styles: assets/kiwi-shop.css. One job:

  1. Free-shipping bar (snippets/kiwi-ship-bar.liquid). Liquid draws it with the cart as it was when the
     page loaded; this keeps it current. The theme fires theme:cart:change with the new cart after every
     add, quantity change and removal; a page restored from the back-forward cache reads /cart.js.

  2. (Removed 2026-10-30, Gaurav: the phone sticky Add to Cart bar came and went at random points,
     made Ask Kiwi jump, and could add a size other than the one picked. The buy box's own button is
     the only Add to Cart.)
*/
(function () {
  if (window.__kwShop) return;
  window.__kwShop = true;

  /* ---------- 1. Free-shipping bar ---------- */
  function money(cents) {
    var d = Math.max(0, cents) / 100;
    var s = d.toFixed(2);
    if (s.slice(-3) === '.00') s = s.slice(0, -3);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function shipBar(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-kw-ship]').forEach(function (el) {
      var goal = parseInt(el.getAttribute('data-kw-ship'), 10) || 10000;
      var total = cart.total_price || 0;
      var left = goal - total;
      var pct = Math.min(100, Math.floor((total * 100) / goal));
      el.classList.toggle('is-empty', !cart.item_count);
      el.classList.toggle('is-done', left <= 0);
      var fill = el.querySelector('.kw-ship__fill');
      if (fill) fill.style.width = pct + '%';
      var bar = el.querySelector('[role="progressbar"]');
      if (bar) bar.setAttribute('aria-valuenow', pct);
      var l = el.querySelector('[data-kw-ship-left]');
      if (l) l.textContent = money(left);
    });
  }
  function readCart() {
    if (!document.querySelector('[data-kw-ship]')) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(shipBar)
      .catch(function () {});
  }
  document.addEventListener('theme:cart:change', function (e) {
    if (e.detail && e.detail.cart) shipBar(e.detail.cart);
    else readCart();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) readCart(); });

})();
